import { create } from 'zustand';
import { useEffect } from 'react';

// Service-worker registration & update (Guide §2.3: 426 upgrade_required → SW update). vite-plugin-pwa "prompt" mode.
let updateSW: ((reload?: boolean) => Promise<void>) | null = null;
const useW = create<{ waiting: boolean }>(() => ({ waiting: false }));

export async function registerSW(): Promise<void> {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  const { registerSW: reg } = await import('virtual:pwa-register');
  updateSW = reg({
    immediate: true,
    onNeedRefresh: () => useW.setState({ waiting: true }),
    onRegisteredSW: (_url, r) => { if (r) setInterval(() => void r.update(), 60 * 60_000); },
  });
}
export const useUpdateAvailable = (): boolean => {
  const w = useW((s) => s.waiting);
  useEffect(() => undefined, []);
  return w;
};
export async function applyUpdate(): Promise<void> {
  if (updateSW) await updateSW(true);
  else location.reload();
}
export function checkForUpdate(): void {
  void navigator.serviceWorker?.getRegistration().then((r) => r?.update());
}
